/**
 * Style props for form field wrapper
 * @property {("none" | "sm" | "md" | "lg" | "full")} [rounded] - Border radius
 * @property {("sm" | "md" | "lg")} [height] - Input height
 * @property {("primary" | "secondary" | "grey" | "dark-grey" | "transparent")} [borderColor] - Border color
 * @property {("primary" | "danger" | "red")} [errorColor] - Border and background color when error
 * @property {("white" | "light-grey" | "transparent")} [backgroundColor] - Background color
 * @property {Object} [disabledStyle] - Styles applied when input is disabled
 * @property {string} [disabledStyle.backgroundColor] - Background color when disabled
 * @property {string} [disabledStyle.borderColor] - Border color when disabled
 * @property {string} [disabledStyle.textColor] - Text color when disabled
 * @property {("none" | "sm" | "md" | "lg")} [padding] - Input padding
 * @property {string} [className] - Additional Tailwind classes
 */
export interface InputWrapperStyleProps {
  rounded?: "none" | "sm" | "md" | "lg" | "full";
  height?: "sm" | "md" | "lg";
  borderColor?: "primary" | "secondary" | "grey" | "dark-grey" | "transparent";
  errorColor?: "primary" | "danger" | "red";
  backgroundColor?: "white" | "light-grey" | "transparent";
  disabledStyle?: {
    backgroundColor?: string;
    borderColor?: string;
    textColor?: string;
  };
  padding?: "none" | "sm" | "md" | "lg";
  className?: string;
}

export const defaultInputWrapperStyles: InputWrapperStyleProps = {
  rounded: "md",
  height: "md",
  borderColor: "dark-grey",
  errorColor: "primary",
  backgroundColor: "transparent",
  padding: "md",
  disabledStyle: {
    backgroundColor: "light-grey",
    borderColor: "dark-grey",
    textColor: "dark-grey",
  },
};

export const inputWrapperStylesMap = {
  height: {
    sm: "h-[36px]",
    md: "h-[48px]",
    lg: "h-[56px]",
  },
  rounded: {
    none: "rounded-none",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  },
} as const;
